import type { ID } from '@phi/newtype';
import type { SubscriptionStatus } from '@phi/subscriptions';
import type { Session } from '@phi/session';

export type AppURLParams = {
    documentId?: ID<'document'>;
    workspaceId?: ID<'workspace'> | '';
    elementId?: ID<'element'>;
    onshape?: undefined;
    error?: string;
    subscription?: SubscriptionStatus;
    server?: string;
    warning?: string;
    expires?: string;
    token?: Session['id'];
    standalone?: '';
    demo?: '';
};

export default function parseParams(query: string = window.location.search): Record<string, unknown> {
    if (!query) return {};
    if (query[0] === '?')
        query = query.slice(1);
    console.log("P4:")
    console.log(query)

    return Object.fromEntries(
        query.split('&')
            .map(x => x.split('=').map(x => decodeURIComponent(x)))
    );
}
